"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOutsideClick = useOutsideClick;
const react_1 = require("react");
const use_identity_ref_1 = require("../use-identity-ref");
const on_1 = require("../../helpers/on");
/**
 * Запускает переданный обработчик при клике вне элемента.
 * @param elementRef Ref элемента, клик вне которого нужно обработать.
 * @param callback Сработает при клике вне элемента.
 */
function useOutsideClick(elementRef, callback) {
    const innerRef = (0, use_identity_ref_1.useIdentityRef)(elementRef);
    const callbackRef = (0, use_identity_ref_1.useIdentityRef)(callback);
    (0, react_1.useEffect)(() => {
        const off = (0, on_1.on)(document.documentElement, 'click', event => {
            const arg = innerRef.current;
            const refs = Array.isArray(arg) ? arg : [arg];
            let isOutside = true;
            for (const { current: element } of refs) {
                if (element &&
                    event.target instanceof Node &&
                    (element === event.target || element.contains(event.target))) {
                    isOutside = false;
                    break;
                }
            }
            isOutside && callbackRef.current?.(event);
        }, 
        // ВАЖНО: чтобы изменение DOM не приводило к ложному срабатыванию
        { capture: true });
        return off;
    }, []);
}
//# sourceMappingURL=index.js.map